import { render, staticRenderFns } from "./testWidget.vue?vue&type=template&id=1b2a2df2&"
import script from "./testWidget.vue.ts?vue&type=script&lang=ts&"
export * from "./testWidget.vue.ts?vue&type=script&lang=ts&"
import style0 from "./testWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports